import { SITE } from '@/constants';

export default function FinalCTA() {
  return (
    <section className="bg-black text-white">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-24 md:py-40 text-center">
        <h2 className="font-display font-medium tracking-tightest text-[clamp(2.4rem,7vw,6.5rem)] leading-[1.02] max-w-5xl mx-auto reveal">
          ¿Tienes un proyecto en mente? Hablemos de él.
        </h2>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 reveal">
          <a
            href="#contacto"
            className="whitespace-nowrap inline-flex items-center justify-center px-8 py-4 text-xs font-medium uppercase tracking-[0.18em] bg-white text-black hover:bg-neutral-200 transition-colors"
          >
            Cotizar proyecto
          </a>
          <a
            href={SITE.whatsappLink}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-4 text-xs font-medium uppercase tracking-[0.18em] border border-white text-white hover:bg-white hover:text-black transition-colors"
          >
            <i className="ri-whatsapp-line text-base"></i> WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}